export const buildMapById = <T extends { id: string }>(items: readonly T[]) =>
  new Map<string, T>(items.map((item) => [item.id, item] as const));
